import "core-js/modules/es.number.constructor.js";
import ColorPicker from "@/pages/design/components/ColorPicker";
import Card from "@/pages/design/components/Card";
import CardItem from "@/pages/design/components/CardItem";
import { getURLFileName } from '@/pages/design/common/utils';
import draggable from "vuedraggable";
import YYImage from "@/pages/design/components/basic/image";
import no_img from '@/assets/noimg.png';
import FormEditPage from '@/pages/design/components/FormEditPage';
import { upload } from '@/services/common';
import SwiperHeightField from '@/pages/design/components/SwiperHeightField';
import InputBar from '@/pages/design/components/InputBar';
import ImgListPdf from '@/pages/design/components/ImgList/imgListPdf.vue';
import InputNumber from '@/pages/design/components/InputNumber';
import InputBarSelect from "@/pages/design/components/InputBar/InputBarSelect.vue";
import SubCard from "@/pages/design/components/subCard/subCard.vue";
export default {
  i18n: require('../../design_i18n'),
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    id: [Number, String]
  },
  components: {
    SubCard: SubCard,
    InputBarSelect: InputBarSelect,
    Card: Card,
    CardItem: CardItem,
    draggable: draggable,
    YYImage: YYImage,
    FormEditPage: FormEditPage,
    SwiperHeightField: SwiperHeightField,
    InputBar: InputBar,
    InputNumber: InputNumber,
    ColorPicker: ColorPicker,
    ImgListPdf: ImgListPdf
  },
  data: function data() {
    return {
      form: this.$form.createForm(this),
      no_img: no_img,
      locationClient: [{
        label: this.$t('form.mobile'),
        value: 2
      }, {
        label: this.$t('form.pc'),
        value: 1
      }],
      /**
       * 下拉列表：大(201px)、中(149px)、小(93px)，自定义
       */
      pcHeight: [{
        label: '201',
        value: 201
      }, {
        label: '149',
        value: 149
      }, {
        label: '93',
        value: 93
      }],
      /**
       * 下拉列表：大(81px)、中(60px)、小(38px)，自定义
       * 数字范围：1-500
       */
      mHeight: [{
        label: '81',
        value: 81
      }, {
        label: '60',
        value: 60
      }, {
        label: '38',
        value: 38
      }]
    };
  },
  methods: {
    handleInput: function handleInput(e) {}
  }
};